import type { TeamMember } from '../types';

// Statuses that count as "in the game". Used for two things:
// 1) the count chip on the role header ("active (total)")
// 2) sinking inactive members (banned, failed, pre_banned) to the
//    end of the Collectors section so the active roster shows first.
const ACTIVE_STATUSES = new Set(['healthy', 'test', 'redemption_test']);

export function isActiveStatus(m: TeamMember): boolean {
  return ACTIVE_STATUSES.has(m.account_status ?? 'healthy');
}

export function activeFirst(members: TeamMember[]): TeamMember[] {
  // Stable sort: leads_count desc within each tier is preserved because
  // the input is already pre-sorted by leads_count on the backend.
  return [...members].sort((a, b) => {
    const aA = isActiveStatus(a);
    const bA = isActiveStatus(b);
    if (aA === bA) return 0;
    return aA ? -1 : 1;
  });
}
